import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/lib/integration/react';

import {history, persistor, store} from './configureStore';
import Preloader from "./Components/Preloader";
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { SplashScreen } from '@capacitor/splash-screen';

const rootElement = document.getElementById('root');



const renderApp = () => {
    ReactDOM.render(
        <Provider store={store}>
            <PersistGate loading={<Preloader/>} persistor={persistor}>
                <React.StrictMode>
                    <App/>
                </React.StrictMode>
            </PersistGate>
        </Provider>,
        rootElement
    );
};

renderApp();


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// Call the element loader after the app has been rendered the first time
defineCustomElements(window);
